import { render, staticRenderFns } from "./DexContent.vue?vue&type=template&id=c05b0f78&scoped=true"
import script from "./DexContent.vue?vue&type=script&lang=js"
export * from "./DexContent.vue?vue&type=script&lang=js"
import style0 from "./DexContent.vue?vue&type=style&index=0&id=c05b0f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05b0f78",
  null
  
)

export default component.exports